module.exports = __webpack_public_path__ + "img/main.md.b40ab763.webp";